import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import {isEmpty} from 'lodash'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table/lib/@types/common'
import IconButton from 'rsuite/esm/IconButton'
import Pagination from 'rsuite/Pagination'
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

//Manual import
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import {ItemType, StateParamsModel} from 'src/app/modules/common/Model'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import {imageBaseUrl} from 'src/cms/helpers/constants'
import * as featuredRedux from '../../featuredImage/redux'
import {IFeaturedState} from '../../featuredImage/redux'
import AddFeatured from './AddFeatured'

const Featured = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
  })
  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const featuredData: IFeaturedState = useSelector((state: any) => state.featured)

  useEffect(() => {
    dispatch(featuredRedux.actions.getFeatured(params))
  }, [params])
  const {
    loading,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    toggleLoading,
    success,
    sortSuccess,
    deleteSuccess,
    sortFeaturedData,
  } = useSelector((state: any) => state?.featured ?? [])

  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const [openSortModal, setOpenSortModal] = useState(false)

  const enableFeaturedData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(featuredRedux.actions.enableFeatured(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableFeaturedData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(featuredRedux.actions.disableFeatured(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    return (
      <Cell {...props} className='link-group'>
        <CheckPermissions type='Edit'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Edit</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              data-cy='edit-button'
              icon={<Edit2 />}
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Delete</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let featuredId = [rowData.id]
                setCheckedValues(featuredId)
              }}
              data-cy='delete-button'
              icon={<TrashIcon />}
            />
          </Whisper>
        </CheckPermissions>
        <Whisper placement='top' trigger='hover' speaker={<Tooltip>Status</Tooltip>}>
          <Toggle
            size='sm'
            disabled={toggleLoading}
            checked={rowData.status}
            onClick={() => handleToggleAction(rowData)}
            data-cy='toggle-button'
          />
        </Whisper>
      </Cell>
    )
  }

  const handleToggleAction = (data: {[key: string]: string}) => {
    data?.status
      ? dispatch(featuredRedux.actions.singleDisableFeatured({id: data.id}))
      : dispatch(featuredRedux.actions.singleEnableFeatured({id: data.id}))
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Title',
      dataKey: 'title',
      flexGrow: 1,
      cell: <Cell dataKey='title' />,
      sortable: true,
    },

    {
      label: 'Thumbnail Image',
      dataKey: 'thumbImage',

      flexGrow: 1,
      height: 500,
      width: 100,
      cell: (
        <Cell>
          {(rowData) => (
            <img
              className='thumbImage '
              src={`${imageBaseUrl}/${rowData?.thumbImage}`}
              alt=''
              width='150'
              height='50'
            />
          )}
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Cover Image',
      dataKey: 'coverImage',

      flexGrow: 1,
      height: 500,
      width: 100,
      cell: (
        <Cell>
          {(rowData) => (
            <img
              className='thumbImage '
              src={`${imageBaseUrl}/${rowData?.coverImage}`}
              alt=''
              width='150'
              height='50'
            />
          )}
        </Cell>
      ),
      sortable: false,
    },

    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.status ? (
              <Tag color='green' size='sm'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Featured deleted successfully')
    }
    if (enableSuccess) {
      toast.success('Featured enabled successfully')
    }
    if (disableSuccess) {
      toast.success('Featured disabled successfully')
    }
    handleChecked([])
    dispatch(featuredRedux?.actions.getFeatured(params))
  }, [deleteSuccess, success, enableSuccess, disableSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Featured enabled successfully')
    }
    if (singleDisableSuccess) {
      toast.success('Featured disabled successfully')
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const data: any = featuredData?.data?.featuredImage
    ? featuredData?.data?.featuredImage?.map((item: any, i: number) => ({
        sn: (params?.page - 1) * params?.limit + (i + 1),
        id: item.id,
        title: item.title,
        titleNp: item.titleNp,
        thumbImage: item.thumbImage,
        coverImage: item.coverImage,
        status: item.status,
        is_featured: item?.is_featured,
        slug: item.slug,
        typeId: item?.type?.id,
        video: item?.video,
        filetype: item?.filetype,
      }))
    : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let featuredId = checkedValues?.map((value) => ({id: value}))
    dispatch(featuredRedux?.actions?.deleteFeatured(featuredId))
    handleAlertClose()
  }
  const handleRefresh = () => {
    dispatch(featuredRedux.actions.getFeatured(params))
  }

  const handleGetAllData = () => {
    setParams({...params, limit: featuredData?.data?.meta?.total})
    dispatch(featuredRedux.actions.getFeatured(params))
  }

  const handleSubmitSort = (data: Array<ItemType>) => {
    let body = {
      featuredImageId: data?.map((item) => ({id: item?.keyId})),
    }
    dispatch(featuredRedux.actions.sortFeatured(body))
  }

  useEffect(() => {
    if (!isEmpty(sortFeaturedData) && sortSuccess) {
      toast.success('Featured sorted successfully')
      dispatch(featuredRedux.actions.sortFeaturedReset())
      setParams({...params, limit: 10})
      dispatch(featuredRedux.actions.getFeatured(params))
      setOpenSortModal(false)
    }
  }, [sortFeaturedData, sortSuccess])

  return (
    <>
      <div className='shadow p-3 bg-white rounded'>
        <DesignComponent
          moduleName='Photo Featured'
          params={params}
          setParams={setParams}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          handleRefresh={handleRefresh}
          exportShow={false}
          importShow={false}
          enableMultiple={enableFeaturedData}
          disableMultiple={disableFeaturedData}
          data={data}
          sortShow={true}
          sortButtonName='Sort'
          handleSubmitSort={handleSubmitSort}
          handleGetAllData={handleGetAllData}
          openSortModal={openSortModal}
          setOpenSortModal={setOpenSortModal}
          loading={loading}
        />

        <div className='datatable'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={data}
            checkedValues={checkedValues}
            showLoading={featuredData?.loading}
            handleSort={handleSort}
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={featuredData?.data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
          />

          <AddFeatured
            open={open}
            params={params}
            handleClose={handleClose}
            actionType={actionType}
            editSelectedData={editSelectedData}
          />
        </div>
        <>
          {alertOpen &&
            (!isEmpty(checkedValues) ? (
              <DeleteModal
                handleClick={() => handleDelete()}
                handleClose={() => handleAlertClose()}
                isOpen={alertOpen}
              />
            ) : (
              toast.error('No data selected') && setAlertOpen(false)
            ))}
        </>
      </div>
    </>
  )
}

export default Featured
